import React, { useState } from 'react';
import { TimeFilter } from '../../../list/components/time-filter/TimeFilter';
import {
  ACTIVATION_STATS_TIME_FILTER_OPTIONS,
  ACTIVATION_STATS_VIEW_FILTER_OPTIONS
} from './constant';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { useActivationStats } from './useActivationStats';
import { HdIcon, HdIconButton, HdMenu, HdMenuItem } from '../../../components';
import ActivationStatsContainer from './ActivationStatsContainer';
import ActivationStatsShimmer from './ActivationStatsShimmer';
import HdMenuTrigger from '../../../menu/components/menu-trigger/HdMenuTrigger';
import { FILTER_ALL } from '../../../list/constants/listFilter';
import styles from './styles.module.scss';


function ActivationStats({ activation }) {
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);

  const {
    stats,
    timeFilter,
    initialLoadStatsFetched,
    fetchingAll,
    onRefreshClick,
    onTimeFilterSelect,
    statsFilter,
    onStatusFilterChange
  } = useActivationStats(activation.id);

  const onStatusFilterTriggerClick = () => {
    setFilterMenuOpen(true);
  };

  const isActiveFilterOption = filter => {
    if (filter.value === FILTER_ALL.value && !statsFilter) {
      return true;
    }

    return statsFilter.value === filter.value;
  };

  const dataIdGenerator = getDataIdGenerator('activationStats');

  return (
    <div>
      <div className='center-flex-row justify-between px-5 pb-5'>
        <span className='text-bold'>Activation Statistics</span>

        <div className='center-flex-row'>
          View:
          <HdMenuTrigger
            onClick={onStatusFilterTriggerClick}
            id='activation_status_filter'
            className='ml-2'
            dataId={dataIdGenerator('filter')}
          >
            {statsFilter.name}
          </HdMenuTrigger>
          <HdMenu
            target='#activation_status_filter'
            open={filterMenuOpen}
            onClose={() => setFilterMenuOpen(false)}
          >
            {ACTIVATION_STATS_VIEW_FILTER_OPTIONS.map((option, index) => (
              <HdMenuItem
                key={index}
                selected={isActiveFilterOption(option)}
                onClick={() => {
                  setFilterMenuOpen(false);
                  onStatusFilterChange(option);
                }}
              >
                {option.name}
              </HdMenuItem>
            ))}
          </HdMenu>
          <div className='filter-separator' />
          <TimeFilter
            dataId={dataIdGenerator('activity')}
            options={ACTIVATION_STATS_TIME_FILTER_OPTIONS}
            activeOption={timeFilter}
            onSelect={onTimeFilterSelect}
          />
          <div className='filter-separator' />
          <HdIconButton
            edge='end'
            onClick={onRefreshClick}
            horizontalEdge='both'
            verticalEdge='both'
            dataId={dataIdGenerator('refresh')}
            className={styles.refreshIcon}
          >
            <HdIcon
              name='refresh'
              size={3}
              className={`refresh-icon ${fetchingAll ? 'refreshing' : ''}`}
            />
          </HdIconButton>
        </div>
      </div>

      <div className='mb-5'>
        {initialLoadStatsFetched && stats ? (
          <ActivationStatsContainer runStageStatsData={stats} />
        ) : (
          <ActivationStatsShimmer />
        )}
      </div>
    </div>
  );
}

export default ActivationStats;
